export default __webpack_public_path__ + "static/media/team-photo-2017.48c32cb2.jpg";